module.exports = __webpack_public_path__ + "static/media/teaserCenter.5895bab7.jpg";